
const category = {
  path: '/mallManage/category',
  component: resolve => require(['@/views/mallManage/category'], resolve),
  name: 'category',
  meta: {title: '类别管理'}
};
const product = {
  path: '/mallManage/product',
  component: resolve => require(['@/views/mallManage/product'], resolve),
  name: 'product',
  meta: {title: '产品管理',keepActive:true}
};
const productsku = {
  path: '/mallManage/productsku',
  component: resolve => require(['@/views/mallManage/productsku'], resolve),
  name: 'productsku',
  meta: {title: '产品SKU管理'}
};
const skulist = {
  path: '/mallManage/skulist',
  component: resolve => require(['@/views/mallManage/skuList'], resolve),
  name: 'skulist',
  meta: {title: '产品SKU列表',keepActive:true}
};
const testRouter = {
  path: '/mallManage/testRouter',
  component: resolve => require(['@/views/mallManage/test'], resolve),
  name: 'testRouter',
  meta: {title: '测试页面'}
};
const coupon = {
  path: '/mallManage/coupon',
  component: resolve => require(['@/views/mallManage/coupon'], resolve),
  name: 'coupon',
  meta: {title: '优惠管理'}
};
const order = {
  path: '/mallManage/order',
  component: resolve => require(['@/views/mallManage/order'], resolve),
  name: 'order',
  meta: {title: '订单管理',keepActive:true}
};
const orderShare = {
  path: '/mallManage/orderShare',
  component: resolve => require(['@/views/mallManage/orderShare'], resolve),
  name: 'orderShare',
  meta: {title: '分账信息',keepActive:true}
};
const ordercomment = {
  path: '/mallManage/ordercomment',
  component: resolve => require(['@/views/mallManage/ordercomment'], resolve),
  name: 'ordercomment',
  meta: {title: '订单评价管理',keepActive:true}
};
const address = {
  path: '/mallManage/address',
  component: resolve => require(['@/views/mallManage/address'], resolve),
  name: 'address',
  meta: {title: '收货地址管理'}
};
const orderSale = {
  path: '/mallManage/orderSale',
  component: resolve => require(['@/views/mallManage/orderSale'], resolve),
  name: 'orderSale',
  meta: {title: '售后管理',keepActive:true}
};

export default [product,category,productsku,skulist,testRouter,coupon,order,orderShare,ordercomment,address,orderSale];

// 管理列表



// WEBPACK FOOTER //
// ./src/router/modules/mallManage.js